<template>
    <div>
        <b-container class="pt-5 pb-5">
            <div class="text-center">
                <img alt="Tixgo" src="../assets/logo_white.svg" class="mb-5" width="120" />
            </div>
            <b-card no-body class="small-card">
                <b-card-body>
                    <div class="text-center mb-4">
                        <h1 class="fs-light">Registreren</h1>
                        <div>
                            Bestaande klant?
                            <router-link to="/account/login" class="link-primary font-weight-bolder">
                                Inloggen op je Account
                            </router-link>
                        </div>
                    </div>
                    <RegisterForm />
                </b-card-body>
            </b-card>
        </b-container>
    </div>
</template>

<script>
    import RegisterForm from '@/components/RegisterForm'

    export default ({
        components: {
            RegisterForm,
        },
        metaInfo: {
            title: 'Registeren',
        },
        data() {
            return {}
        },
        methods: {}
    });
</script>

<style scoped>
    .small-card{
        max-width:90%;
        margin:auto;
    }

    @media screen and (min-width:600px) {
        .small-card{
            max-width:500px;
        }
    }
</style>